import { CatalogueType } from '@/config/types'
import { PUBLICATION_CODE } from '@/constants'
import { AtLeastOne, PublicationCode, SiteName } from '@/scopes/common/domain/types'

export function getPublicationCodeByCatalogueAndSiteName(catalogue: CatalogueType, siteName: SiteName): PublicationCode {
  const publicationCodes: Record<SiteName, AtLeastOne<Record<CatalogueType, PublicationCode>>> = {
    sunwebnl: { summer: PUBLICATION_CODE.SUNWEB_NL_SUMMER, winter: PUBLICATION_CODE.SUNWEB_NL_WINTER },
    sunwebde: { winter: PUBLICATION_CODE.SUNWEB_DE_WINTER },
    sunwebfr: { summer: PUBLICATION_CODE.SUNWEB_FR_SUMMER, winter: PUBLICATION_CODE.SUNWEB_FR_WINTER },
    sunwebdk: { summer: PUBLICATION_CODE.SUNWEB_DK_SUMMER, winter: PUBLICATION_CODE.SUNWEB_DK_WINTER },
    sunwebuk: { winter: PUBLICATION_CODE.SUNWEB_UK_WINTER },
    sunwebse: { summer: PUBLICATION_CODE.SUNWEB_SE_SUMMER, winter: PUBLICATION_CODE.SUNWEB_SE_WINTER },
    sunwebbenl: { summer: PUBLICATION_CODE.SUNWEB_BE_NL_SUMMER, winter: PUBLICATION_CODE.SUNWEB_BE_NL_WINTER },
    sunwebbefr: { summer: PUBLICATION_CODE.SUNWEB_BE_FR_SUMMER, winter: PUBLICATION_CODE.SUNWEB_BE_FR_WINTER },
    elizanl: { summer: PUBLICATION_CODE.ELIZA_NL_SUMMER },
    elizabe: { summer: PUBLICATION_CODE.ELIZA_BE_SUMMER },
    elizauk: { summer: PUBLICATION_CODE.ELIZA_UK_SUMMER },
    gogonl: { summer: PUBLICATION_CODE.GOGO_NL_SUMMER },
  }

  const publicationCode = publicationCodes[siteName][catalogue]

  if (!publicationCode) {
    throw new Error(`No matching publication code for siteName: ${siteName} and catalogue: ${catalogue}`)
  }

  return publicationCode
}
